import { render, staticRenderFns } from "./Ireland.vue?vue&type=template&id=7b4f0a64&"
import script from "./Ireland.vue?vue&type=script&lang=js&"
export * from "./Ireland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b4f0a64')) {
      api.createRecord('7b4f0a64', component.options)
    } else {
      api.reload('7b4f0a64', component.options)
    }
    module.hot.accept("./Ireland.vue?vue&type=template&id=7b4f0a64&", function () {
      api.rerender('7b4f0a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Ireland.vue"
export default component.exports